"use client";

import { motion } from "framer-motion";

import { ForgotPasswordForm } from "./forgot-password-form";

export function ForgotPasswordClient() {
    return (
        <main className="dark min-h-screen relative overflow-hidden bg-[#02040a] text-white font-sans">
            <div className="absolute inset-0 zp-starfield" />
            <div className="absolute inset-0 zp-vignette pointer-events-none" />
            <div className="absolute inset-0 zp-noise pointer-events-none" />

            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600/10 blur-[120px] rounded-full animate-pulse" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-cyan-600/10 blur-[120px] rounded-full animate-pulse" style={{ animationDelay: '2s' }} />

            <div className="relative min-h-screen flex items-center justify-center p-4">
                <motion.div
                    initial={false}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="w-full flex justify-center max-w-lg z-10"
                >
                    <ForgotPasswordForm />
                </motion.div>
            </div>
        </main>
    );
}
